import BigButton from 'components/buttons/bigButton'
import React, { useEffect, useState, useContext } from 'react'
import crumbContext from "contexts/crumbs"
import AliceCarousel from 'react-alice-carousel';
import "./accueil.scss"
import ButtonsContainer from 'components/buttons/buttonsContainer';
export default function Accueil(props) {
    const {items} = props
    const {crumbs, setCrumbs} = useContext(crumbContext)
    const buttons = [
        {
            title : "Mon parcours de formation",
            icon : "picto parcours de formation - v2.svg",
            buttonBackground : "bckDarkBlue",
            headbandBackground : "bckDarkBlue",
            page : "/accueil/parcours_formation",
            right : "600px",
            delay : "0"
        },
        {
            title : "Ma DRHF",
            icon : "drhf.svg",
            buttonBackground : "bckGreen",
            page : "/accueil/drhf",
            top : "-600px",
            delay : "0"
        },
        {
            title : "Mon parcours d'évolution professionnelle",
            icon : "picto parcours evolution professionnelle - v2.svg",
            buttonBackground : "bckRed",
            page : "/accueil/parcours_evolution",
            left : "600px",
            delay : "0"
        },
        {
            title : "Votre avis nous intéresse",
            icon : "picto vote - v2.svg",
            buttonBackground : "bckOrange",
            page : "/accueil/avis",
            right : "600px",
            delay : "200"
        },
        {
            title : "Site Carrière",
            icon : "picto site carriere - v3.svg",
            buttonBackground : "bckPink",
            page : "/accueil/site",
            left : "600px",
            delay : "200"
        },
    ]
    useEffect(() => {
        document.title = "Accueil"
        setCrumbs([
            {
                title : "Accueil",
                page : "/accueil",
                icon : "",
                color : ""
            }
        ])
    }, [])
    return (
        <div id="accueil" className='w100 h100'>
            <div id="carousel">
                <AliceCarousel 
                    animationDuration={500}
                    autoPlayInterval={5000}
                    autoPlay={true}
                    items={items}
                    disableButtonsControls={true}
                    disableDotsControls={true}
                    infinite={true}
                    animationType="slide"
                />
                <div className="bulle flex column center">
                    <img src="/finger-white.svg" alt="" />
                    <p>
                        Écran tactile
                    </p>
                    
                </div>
            </div>
            <div className='w100' style={{padding : "50px 0"}}>
                <ButtonsContainer buttons={buttons} url="/accueil"/>            
            </div>
            <div id="bandeau">
                <span className='txt'>
                    Tout savoir sur votre formation et votre parcours pro&nbsp;&nbsp;-&nbsp;&nbsp;
                </span>
                <span className='txt'>
                    Tout savoir sur votre formation et votre parcours pro&nbsp;&nbsp;-&nbsp;&nbsp;
                </span>
            </div>
        </div>  
    )
}
